// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from 'react';

const Unfavorite: React.FC = ()=>(
<svg  focusable="false" width="13" height="13" viewBox="0 0 13 13" >
    <path fill="currentColor" d="M7.427.922a.751.751 0 0 0-1.35 0l-1.507 3.1-3.365.498a.748.748 0 0 0-.417 1.275L3.23 8.21l-.577 3.415a.752.752 0 0 0 1.095.787l3.007-1.605 3.007 1.605a.75.75 0 0 0 1.094-.787l-.579-3.415 2.443-2.416a.75.75 0 0 0-.418-1.275l-3.367-.497z"/>
</svg>
);

export default React.memo(Unfavorite);
